<template>
  <div class="home">
    <h1>This is the HomeView</h1>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'HomeView',
}
</script>
